import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../components/global/Button';
import EditIcon from '../../../../../components/icons/EditIcon';
import TrashIcon from '../../../../../components/icons/TrashIcon';
import DotTrigger from '../../../../../components/global/DotTrigger';
import useClickOutside from '../../../../../hooks/useClickOutside';
import CustomControl from '../../../../../components/global/CustomControl';

const propTypes = {
  className: PropTypes.string,
  address: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    post_code: PropTypes.string,
    country: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  selectable: PropTypes.bool,
};

const AddressListItem = ({
  className,
  address,
  selected,
  onClick,
  onDelete,
  onEdit,
  selectable,
}) => {
  const ref = useRef(null);
  const [actionsVisible, setActionsVisible] = useState(false);

  useClickOutside(ref, () => {
    if (actionsVisible) {
      setActionsVisible(false);
    }
  });

  const classes = classNames({
    'address-list-item': true,
    'is-selected': selected,
    'actions-visible': actionsVisible,
    [className]: !!className,
  });

  return (
    <a
      href="#"
      ref={ref}
      className={classes}
      onClick={event => {
        event.preventDefault();

        if (actionsVisible) {
          setActionsVisible(false);
          return;
        }

        onClick?.(address);
      }}
    >
      <div className="address-list-item-info">
        <span className="address-list-item-row address-list-item-row-primary">
          {address.name}
        </span>
        <span className="address-list-item-row">{address.address_line_1}</span>
        <span className="address-list-item-row">{address.address_line_2}</span>
        <span className="address-list-item-row">
          {[address.city, address.state, address.post_code].join(', ')}
        </span>
        <span className="address-list-item-row">{address.country?.name}</span>

        {(selected || selectable) && (
          <CustomControl
            id={`checkbox-${address.id}`}
            label="Select this contact"
            labelSrOnly
            size="lg"
            type="checkbox"
            checked={selected}
            readOnly
            className="address-list-item-selected-icon"
          />
        )}
      </div>

      {(onEdit || onDelete) && (
        <div className="address-list-item-actions">
          <DotTrigger
            className="address-list-item-actions-toggle"
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              setActionsVisible(prev => !prev);
            }}
          />

          {onEdit && (
            <Button
              btnSize="xs"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onEdit(address);
              }}
            >
              <EditIcon color="#fff" size="14" />
            </Button>
          )}

          {onDelete && (
            <Button
              btnStyle="danger"
              btnSize="xs"
              onClick={event => {
                event.preventDefault();
                event.stopPropagation();
                onDelete(address);
              }}
            >
              <TrashIcon color="#fff" />
            </Button>
          )}
        </div>
      )}
    </a>
  );
};

AddressListItem.propTypes = propTypes;

export default AddressListItem;
